var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickmarkcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.242,
    height: 56.242,
    viewBox: "0 0 56.242 56.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M58.242,10.942,26.156,43.057,14.233,31.133,18.2,27.168l7.958,7.958L54.277,7.006ZM52.027,25.115A22.482,22.482,0,1,1,30.121,7.624a22.274,22.274,0,0,1,12.036,3.515L46.206,7.09A27.839,27.839,0,0,0,30.121,2,28.2,28.2,0,1,0,56.555,20.588Z",
    transform: "translate(-2 -2)",
    fill: "rgba(255,255,255,0.8)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmarkcircle);
export default __webpack_public_path__ + "static/media/tickmarkcircle.ab7b9196172edd40bf36e223a8bef6d3.svg";
export { ForwardRef as ReactComponent };